import { createSlice } from '@reduxjs/toolkit'
import type { PayloadAction } from '@reduxjs/toolkit'
import { User } from '../../Interfaces/bucket/User';


export interface UserState {
    user: User;
    wallet?: string;
    rank?: number;
}

const initialState: UserState = {
    user: {},
    wallet: "",
    rank: 0
}

export const userSlice = createSlice({
    name: 'user',
    initialState,
    reducers: {
        changeUser: (state, action: PayloadAction<User>) => {
            // TODO: Better approach is to migrate all existing records on server side
            if (action.payload && !action.payload.coin) {
                action.payload.coin = "AVAX";
            }
            state.user = action.payload;
        },
        changeWallet: (state, action: PayloadAction<string>) => {
            state.wallet = action.payload;
        },
        changeRank: (state, action: PayloadAction<number>) => {
            state.rank = action.payload;
        }
    },
})

// Action creators are generated for each case reducer function
export const { changeUser, changeWallet, changeRank } = userSlice.actions

export default userSlice.reducer